import { getFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { type IRenderContextMenuItemArgs } from '@/plugins/context-menu';
import { GroupLayerHotkeyType } from '../../type';

export const groupPackItem = ({ activeLayer }: IRenderContextMenuItemArgs, identity: string) => {
    const { $t } = getLocaleStore();
    const framework = getFramework(identity);

    if (!activeLayer) return null;

    const type = GroupLayerHotkeyType.PACK;
    const item = {
        disabled:
            !framework.service.flatLayer.checkIsExtraGroup(activeLayer) ||
            framework.service.agentLayout.checkArranging(activeLayer),
        name: $t((v) => v.contextMenuLayer.menuConfig.makeGroup),
        type,
        desc: framework.service.hotkey.getDesc(type),
        onClick: () => {
            framework.service.hotkey.__emit(type, { from: 'content-menu' });
        },
    };

    return item;
};
